import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";
import { DICTS } from "@/lib/i18n";

export const Route = createFileRoute("/account/ledger")({
  component: lazyRouteComponent(() => import("./-pages/account.ledger")),
  head: () => ({
    meta: [
      { title: DICTS.en["account.ledger.meta_title"] ?? "Wallet history" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
});
